import apiClient from "../helper/apiClient";
import { get } from "lodash";
import { validateUserKey } from "./validateUserKey";

export default async function getCRMDetailsSearch(requestObject, userKey) {
  validateUserKey(userKey);
  try {
    const { data } = await apiClient.post("api/searchCRMCallDetails", {
      ...requestObject,
      userKey,
    });
    const respOptions = get(data, "data", []);
    return respOptions;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
